import PropTypes from "prop-types";
import { FilterTag } from "../../../Common/FiltersList";
import { interactionEventDataLayer } from "../../../../utils/DataLayers";
import { getEnrollmentIcon } from "../../../../core/utils";

const ENROLLMENT_STATUSES = [
  {
    key: FilterTag.ENROLLMENT_1_INTERESTED,
    label: "Interested",
    analyticsEvent: "all_st_interested_filter"
  },
  {
    key: FilterTag.ENROLLMENT_2_APPLIED,
    label: "Applied",
    analyticsEvent: "all_st_applied_filter"
  },
  {
    key: FilterTag.ENROLLMENT_0_DENIED,
    label: "Denied",
    analyticsEvent: "all_st_denied_filter"
  },
  {
    key: FilterTag.ENROLLMENT_21_DEFERRED,
    label: "Deferred",
    analyticsEvent: "all_st_deferred_filter"
  },
  {
    key: FilterTag.ENROLLMENT_22_WAITLISTED,
    label: "Waitlisted",
    analyticsEvent: "all_st_waitlisted_filter"
  },
  {
    key: FilterTag.ENROLLMENT_3_ACCEPTED,
    label: "Accepted",
    analyticsEvent: "all_st_accepted_filter"
  },
  {
    key: FilterTag.ENROLLMENT_4_UPLOADED_LETTER,
    label: "Uploaded letter",
    analyticsEvent: "all_st_uploaded_letter_filter"
  },
  {
    key: FilterTag.ENROLLMENT_5_ENROLLED,
    label: "Enrolled",
    analyticsEvent: "all_st_enrolled_filter"
  }
];

const NO_COLLEGE_STATUS = {
  key: FilterTag.NO_COLLEGE,
  label: "No college added",
  analyticsEvent: "all_st_no_college_added_filter"
};

function EnrollmentStatusFilter({ onSelect }) {
  const size = 18;

  const handleSelect = (status) => {
    onSelect({ key: status.key });
    if (status.analyticsEvent) {
      interactionEventDataLayer({ eventName: status.analyticsEvent });
    }
  };

  const commonItemClasses =
    "flex flex-row mx-2 space-x-4 items-center cursor-pointer";

  return (
    <div className="flex text-sm flex-col divide-y space-y-4 capitalize divide-solid divide-black">
      <div className="flex flex-col space-y-3">
        {ENROLLMENT_STATUSES.map((status) => (
          <div
            key={status.key}
            onClick={() => handleSelect(status)}
            className={commonItemClasses}
          >
            {getEnrollmentIcon({ size, enrollment: status.key })}
            <span className="pl-2">{status.label}</span>
          </div>
        ))}
      </div>
      <div className="pt-2 flex flex-col">
        <div
          className="py-2 flex flex-row cursor-pointer"
          onClick={() => handleSelect(NO_COLLEGE_STATUS)}
        >
          <div className="w-10">
            <div className="h-full w-full bg-light-gray" />
          </div>
          <span className="pl-4">{NO_COLLEGE_STATUS.label}</span>
        </div>
      </div>
    </div>
  );
}

EnrollmentStatusFilter.propTypes = {
  onSelect: PropTypes.func.isRequired
};

export default EnrollmentStatusFilter;
